import { render, staticRenderFns } from "./OrganisationList.vue?vue&type=template&id=4d7b82cd"
import script from "./OrganisationList.vue?vue&type=script&lang=js"
export * from "./OrganisationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d7b82cd')) {
      api.createRecord('4d7b82cd', component.options)
    } else {
      api.reload('4d7b82cd', component.options)
    }
    module.hot.accept("./OrganisationList.vue?vue&type=template&id=4d7b82cd", function () {
      api.rerender('4d7b82cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Organisation/OrganisationList.vue"
export default component.exports